<template>
  <div class="shop_wrapper">
    <div class="container">
      <div class="row">  
        <div v-if=" !getLoggedIn " class="col-lg-6 col-md-6 offset-md-3">
          <div class="account_form login">
            <h4>Login</h4>
            <form v-on:submit.prevent="login">
              <p>   
                <label>{{ $t('Usuario') }} <span>*</span></label>
                <input v-model="user" type="text" autocomplete="username">
                </p>
                <p>   
                  <label>{{ $t('Contraseña') }} <span>*</span></label>
                  <input v-model="pwd" type="password" autocomplete="current-password">
                </p>   
              <div class="login_submit">
                <button @click="login" tag="button">{{ $t('Login') }}</button>
                <a href="#"></a>
              </div>
            </form>
          </div>
        </div>
        <div v-else class="col-lg-6 col-md-6 offset-md-3">
          <div class="login_submit text-center mt-100 mb-100">
            <button @click="logout">{{ $t('Cerrar Sesión') }}</button>
          </div>
        </div>
      </div>   
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "Usuario": "Usuario",
      "Contraseña": "Contraseña",
      "Login": "Login",
      "¿Recuperar contraseña?": "¿Recuperar contraseña?",
      "Cerrar Sesión": "Cerrar Sesión"
    },
    "en": {
      "Usuario": "User",
      "Contraseña": "Password",
      "Login": "Login",
      "¿Recuperar contraseña?": "¿Recover Password?",
      "Cerrar Sesión": "Close session"
    }
  }
</i18n>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  
  export default {
    data () {
	    return {
        user: '',
        pwd: '',
	      msg: ''
	    }
		},
    computed: {
      ...mapGetters(['getLocale', 'getLoggedIn', 'getBaseUrl', 'getApiUrl'])
    },
    methods: {
      ...mapMutations(['mutateLoggedIn']),
      login() {
        this.$axios.get(this.getBaseUrl + 'procure/login-check.php?usr_login=' + this.user + '&usr_password=' + this.pwd )
        .then( (respuesta) =>{ 
          //console.log(respuesta)
          this.$router.push({ name: 'content' })
        })
        .catch( (error) =>{ 
          console.log(error)
        })
      },
      logout(){
        console.log(this.getBaseUrl)
        this.$axios.get(this.getBaseUrl + 'procure/logout.php')
        .then( (respuesta) =>{ 
          //console.log(respuesta)
          this.$store.commit('mutateLoggedIn', false)
        })
        .catch( (error) =>{ 
          console.log(error)
        })

        
      }
    },
  }
</script>
